import { connect } from 'react-redux';
import { ChangeEvent } from 'react';

import { IKnmErknmFormResultDecision } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormResultDecision';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';

import { ErknmResultDecisionDocument } from '../../../ErknmResultDecisionDocument';
import { getTitleFieldWithRedStar } from '../../../../../../functions/getTitleFieldWithRedStar';
import { KnmLateFieldsRemark } from '../../../../../../KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';
import { TextareaField } from '../../../../../../UIPackage/MainModule/components/TextareaField';
import { KnmCollapse } from '../../../../../../KnmPackage/MainModule/components/KnmCollapse';
import { SelectInputField } from '../../../../../../UIPackage/MainModule/components/SelectInputField';
import { ISelectOption } from '../../../../../../UIPackage/MainModule/components/SelectInput';
import { ResultDecisionsItemContentSubject } from '../ResultDecisionsItemContentSubject/ResultDecisionsItemContentSubject';
import { IKnmErknmOrganizationTemplateSelectOption } from '../../../../../MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { KnmKindCodesEnum } from '../../../../../../APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { IKnmForm } from '../../../../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { resultDecisionSubjectTypeOptions } from '../../../../../ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActSubject/components/ErknmSubjectAddDecision';
import { Hint } from '../../../../../../CorePackage/MainModule/components/Hint';
import styles from './ErknmResultDecisionsSellersDecisionContent.module.scss';
import { ResultDecisionsItemContentActs } from '../ResultDecisionsItemContentActs/ResultDecisionsItemContentActs';
import { IKnmErknmFormAct } from '../../../../../MainModule/interfaces/IKnmErknmFormAct';
import { parseDate } from '../../../../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_MINUTE_FNS } from '../../../../../../CorePackage/MainModule/constants/dateFormats';
import {
  normalizeProductsDescription,
  parseProductsDescription,
} from '../../../../../../CorePackage/MainModule/common/parseProductsDescription';
import { isProductSalesSuspensionLocked } from '../../../../../MainModule/common/getErknmProductSalesSuspensionValidate';
import { parseProductSalesFormDate } from '../../../../../MainModule/common/productSalesSuspensionDates';
import { CheckboxField } from '../../../../../../UIPackage/MainModule/components/CheckboxField';

export const sellersOptions: ISelectOption[] = [
  {
    id: 0,
    label: 'Контролируемое лицо',
    value: false,
  },
  {
    id: 1,
    label: 'Неограниченный круг лиц',
    value: true,
  },
];

interface IErknmResultDecisionsSellersDecisionContentProps {
  actsValue: IKnmErknmFormAct[] | undefined;
  decisionIndex: number;
  formRef: IKnmFormRef | undefined;
  id: string;
  isLater4111ForDecision: boolean;
  isWatchOnly: boolean;
  kindKnmCode: KnmKindCodesEnum | undefined;
  lateFieldName: string;
  name: string;
  resultDecisionOrganizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  resultDecisions: IKnmErknmFormResultDecision[] | undefined;
  value: IKnmErknmFormResultDecision;
}

const ErknmResultDecisionsSellersDecisionContentWithoutStore = ({
  actsValue,
  decisionIndex,
  formRef,
  id,
  isLater4111ForDecision,
  isWatchOnly,
  kindKnmCode,
  lateFieldName,
  name,
  resultDecisionOrganizationsTemplatesSelectOptions,
  resultDecisions,
  value,
}: IErknmResultDecisionsSellersDecisionContentProps) => {
  const isLocked = isWatchOnly || isProductSalesSuspensionLocked(value);
  const activeAct = actsValue?.find(act => act.guid === value?.act?.value);
  const minDate = activeAct?.holdingDateTime
    ? parseDate({ date: activeAct?.holdingDateTime, parseFormat: DATE_FORMAT_LONG_MINUTE_FNS })
    : undefined;

  const handleIndefiniteChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      formRef?.current.change(`${name}.validTo` as keyof IKnmForm, undefined);
    }
  };

  return (
    <>
      <ResultDecisionsItemContentActs
        resultDecisionId={id}
        name={name}
        acts={actsValue}
        watchOnly={isLocked}
        resultDecisions={resultDecisions}
        formRef={formRef}
      />
      <div className={styles.DecisionForm}>
        <div className={styles.NumberRow}>
          <FieldBlock
            className={styles.FormField}
            label={getTitleFieldWithRedStar({
              label: 'Номер решения',
              field: `${name}.numberDecision`,
              isKnm: true,
            })}
            id={`${id}.numberDecision`}
            tooltip={
              <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/numberDecision`} fieldId={`${id}.numberDecision`} />
            }
          >
            <TextInputField name={`${name}.numberDecision`} disabled={isWatchOnly || !!value.signed} />
          </FieldBlock>
        </div>
        <div className={styles.DatesRow}>
          <FieldBlock
            className={styles.FormField}
            label={getTitleFieldWithRedStar({
              label: 'Дата выдачи предписания',
              field: `${name}.dateDecision`,
              isKnm: true,
            })}
            id={`${id}.dateDecision`}
            tooltip={
              <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/dateDecision`} fieldId={`${id}.dateDecision`} />
            }
          >
            <DatePickerField name={`${name}.dateDecision`} disabled={isWatchOnly || !!value.signed} minDate={minDate} />
          </FieldBlock>
          <FieldBlock
            className={styles.FormField}
            label={getTitleFieldWithRedStar({
              label: 'Дата окончания действия предписания',
              field: `${name}.validTo`,
              isKnm: true,
            })}
            id={`${id}.validTo`}
            tooltip={<KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/validTo`} fieldId={`${id}.validTo`} />}
          >
            <div className={styles.ValidToRow}>
              <div className={styles.ValidToDate}>
                <DatePickerField
                  name={`${name}.validTo`}
                  disabled={isLocked || !!value.isIndefinite}
                  minDate={value.dateDecision ? parseProductSalesFormDate(value.dateDecision) || undefined : undefined}
                />
              </div>
              <div className={styles.IndefiniteCheckbox}>
                <CheckboxField
                  name={`${name}.isIndefinite`}
                  className={styles.IndefiniteCheckboxControl}
                  theme="system"
                  id={`${id}.isIndefinite`}
                  type="checkbox"
                  label="Бессрочно"
                  disabled={isLocked}
                  onChange={handleIndefiniteChange}
                />
              </div>
            </div>
          </FieldBlock>
        </div>
        <FieldBlock
          color="black"
          label={getTitleFieldWithRedStar({
            label: 'Перечень продукции (товаров)',
            field: `${name}.productsDescription`,
            isKnm: true,
          })}
          id={`${id}.productsDescription`}
          margin="bottom"
        >
          <TextareaField
            name={`${name}.productsDescription`}
            disabled={isWatchOnly || !!value.signed}
            resize="vertical"
            parse={parseProductsDescription}
            format={normalizeProductsDescription}
            formatOnBlur
          />
          <Hint text="При описании продукции укажите также идентифицирующие сведения об изготовителе: полное наименование, ИНН, ОГРН, адрес места нахождения и адрес осуществления деятельности" />
        </FieldBlock>
      </div>
      <ErknmResultDecisionDocument
        isWatchOnly={isWatchOnly || !!value.signed}
        name={`${name}.document.attachments`}
        attachmentsNumber={value.document?.attachments?.length || 0}
        isRequired={false}
        decisionIndex={decisionIndex}
        formRef={formRef}
        id={`${id}.document.attachments`}
        className={styles.MarginBottom}
        lateFieldName={
          value.document?.attachments && value.document?.attachments[0]?.guid
            ? `${lateFieldName}/document/attachments/${value.document?.attachments[0]?.guid}/fileName`
            : undefined
        }
      />
      <KnmCollapse title="Получатель предписания" opened={true}>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'Получатель предписания',
            field: `${name}.prescriptionForUnidentifiedPersons`,
            isKnm: true,
          })}
        >
          <SelectInputField
            name={`${name}.prescriptionForUnidentifiedPersons`}
            id={`${id}.prescriptionForUnidentifiedPersons`}
            isClearable={false}
            disabled={isWatchOnly || !!value.signed}
            options={sellersOptions}
            placeholder="Выберите получателя предписания"
            onChange={() =>
              formRef?.current.change(
                `${name}.subjectTypeFounder` as keyof IKnmForm,
                resultDecisionSubjectTypeOptions[0],
              )
            }
          />
          {value.prescriptionForUnidentifiedPersons?.value === false && (
            <ResultDecisionsItemContentSubject
              id={id}
              kindKnmCode={kindKnmCode}
              organizationsTemplatesSelectOptions={resultDecisionOrganizationsTemplatesSelectOptions}
              name={name}
              value={value}
              isLater4111ForDecision={isLater4111ForDecision}
            />
          )}
          {value.prescriptionForUnidentifiedPersons?.value === true && (
            <Hint text="Выбор контролируемого лица не выполняется. Предписание распространяется на продавцов продукции, указанной в поле «Перечень продукции (товаров)»" />
          )}
        </FieldBlock>
      </KnmCollapse>
    </>
  );
};

export const ErknmResultDecisionsSellersDecisionContent = connect(null)(
  ErknmResultDecisionsSellersDecisionContentWithoutStore,
);
